module.exports = __webpack_public_path__ + "static/hero-bg-mobile-63f71ebf5057a06646222e8dbf7ccaf6.jpg";